import { logUtil, getObjectUtil } from 'packages/src'
import getImageUriPlanUtil from '../../../../modules/plan/model/utils/get-image-uri'
import getImageUriWorkoutUtil from '../../../../modules/workout/model/utils/get-image-uri'
import { EXERCISE_CLASS_NAME } from '../../../exercise'
import { deleteFileAction } from '../../../files/actions/delete-unused'
import { PLAN_CLASS_NAME } from '../../../plan'
import { POST_CLASS_NAME } from '../../../post/model/constants'
import saveReduxAction from '../save'
import REDUX_ACTION from '../../constants/action'
import getClassNameReduxUtil from '../../utils/get-class-name'
import isNewReduxUtil from '../../utils/is-new'
import { WORKOUT_CLASS_NAME } from '../../../workout'
import getImageUriExerciseUtil from '../../../exercise/model/utils/get-image-uri'
import getVideoUriExerciseUtil from '../../../exercise/model/utils/get-video-uri'
import { getImageUriPostUtil } from '../../../post'

const CLASS_NAME_TO_URI_GETTERS = {
  [EXERCISE_CLASS_NAME]: [
    getImageUriExerciseUtil,
    getVideoUriExerciseUtil
  ],
  [POST_CLASS_NAME]: [
    getImageUriPostUtil
  ],
  [PLAN_CLASS_NAME]: [
    getImageUriPlanUtil
  ],
  [WORKOUT_CLASS_NAME]: [
    getImageUriWorkoutUtil
  ],
  [EXERCISE_CLASS_NAME]: [
    getImageUriExerciseUtil
  ]
}

function deleteLocallyReduxAction (action) {
  return async (dispatch, getState) => {
    dispatch({
      reduxType: REDUX_ACTION.DELETE_LOCALLY,
      type: action.type,
      payload: action.payload
    })

    const { path } = action.payload
    const instance = getObjectUtil(getState(), path)
    if (!instance) {
      return
    }

    const className = getClassNameReduxUtil(instance)
    const uriGetters = CLASS_NAME_TO_URI_GETTERS[className]
    if (uriGetters) {
      Promise.all(uriGetters.map(async uriGetter => {
        const uri = uriGetter && uriGetter(instance)
        if (uri) {
          await deleteFileAction(uri)
        }
      }))
    }
  }
}

/**
 * Deletes the `value` at the given `payload.path`.
 * @param {Object} action
 *        {string} action.type
 *        {string} action.reduxType
 *        {Object} action.payload
 *        {string} payload.path
 *        {string} [payload.domainListPath]
 *        {string} [payload.endpoint]
 */
function deleteReduxAction (action) {
  return async (dispatch, getState) => {
    const { payload } = action
    const {
      path,
      endpoint
    } = payload

    const instance = getObjectUtil(getState(), path)
    if (!instance) {
      logUtil('').warn(`instance does not exist with path ${path}`)
      return
    }

    if (!isNewReduxUtil(instance) && endpoint) {
      // If the instance is saved, delete it on the server
      dispatch(saveReduxAction({
        type: REDUX_ACTION.DELETE,
        payload: {
          ...payload,
          method: 'DELETE'
        }
      }))
    }

    // Delete the instance locally
    // For existing instance it will only remove the instance from
    // the domain lists then delete it locally once the `saveReduxAction`
    // is done
    return dispatch(deleteLocallyReduxAction(action))
  }
}

export default deleteReduxAction
